import { csrfFetch } from 'javascripts/csrf_token';
import React from 'react';
import UserSelector from '../UserSelector/UserSelector';
import { type UserSelectorProps } from '../UserSelector/UserSelector';

type WatchersProps = Omit<UserSelectorProps, 'onSelect' | 'onClear'> & {
  toggleUrl?: string;
  clearUrl?: string;
};

const Watchers: React.FC<WatchersProps> = ({
  toggleUrl,
  clearUrl,
  ...props
}) => {
  const selectCallback = user_id => {
    return csrfFetch(toggleUrl, {
      method: 'PUT',
      body: JSON.stringify({
        watch: {
          user_id,
        },
      }),
    });
  };

  const clearCallback = () => {
    return csrfFetch(clearUrl, {
      method: 'DELETE',
    });
  };

  return (
    <UserSelector
      {...props}
      onSelect={selectCallback}
      onClear={clearCallback}
    />
  );
};

export default Watchers;
